/* eslint-disable */
import moment from 'moment';
import getSymbolFromCurrency from 'currency-symbol-map';
import { clientMedia } from './Config/Settings';


import {BAND, MUSICIAN, MOBILE_SMALL_WIDTH, MOBILE_SIZE, MOBILE_SMALL_HEIGHT, LIVE_MUSIC, SERVICE} from './consts';

export const getInstrumentIcon = (instrument, isOn) => {
    return `${clientMedia()}/img/instruments/${instrument}${isOn ? '-on' : ''}.svg`
};

export const shortenStr = (str, maxChars) => {
    if (!str || typeof str !== 'string') return str;

    if (str.length < maxChars) return str;

    return `${str.slice(0, maxChars)}...`
};

export const formatMusicStyles = (rawStr, isBand, isLiveMusic) => {
    const dataText = isBand ? rawStr.replace('player', '') : rawStr.replace('band', '');
    const suffixText = isBand ? '' : 'band';

    return `${dataText} ${!isLiveMusic ? suffixText : ''}`
};

export const getIamACat = (cat, datatypeCats) => {
    if (!datatypeCats) return '';

    const catObj = datatypeCats.find(c => c.name === cat) || {};

    return catObj.text;
}

export const invertBandFinder = bandFinderType => {
    return bandFinderType === BAND ? MUSICIAN : BAND;
}

export const formatPrices = pricesObj => {
    if (!pricesObj) return '';

    if (pricesObj.priceType === 'free') return 'חינם'
    if (pricesObj.priceType === 'hat') return 'כובע'

    if (pricesObj.max && pricesObj.max > 0) return `${pricesObj.min}- ${pricesObj.max} ${getSymbolFromCurrency(pricesObj.currency) || 'ILS'}`;

    if (pricesObj.price) return `${pricesObj.price} ${getSymbolFromCurrency(pricesObj.currency) || '₪'}`;

    return '';
};

export const getDate = (date, time) => {
    let dateText = moment(date).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'D.M ddd'
    });
    let hours = Math.floor(time/3600);
    let minutes = Math.floor((time - Math.floor(time/3600)*3600)/60);
    let timeText = hours + ":" + (minutes>10?minutes:"0"+minutes);
    return (dateText + ", " + timeText);
};

export const getHours = time => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time - Math.floor(time / 3600) * 3600) / 60);

    return hours + ":" + (minutes > 10 ? minutes: "0" + minutes);
};

export const makeLinkFromString = (s) => {
    if (!s) return '';

    const strNoSpaces = s.replaceAll(' ', '');

    const httpPatern = /(http(s?))\:\/\//gi;
    if (httpPatern.test(strNoSpaces)) return strNoSpaces;

    return 'http://' + strNoSpaces;
};

export const isMobile = () => {
    return window.innerWidth < MOBILE_SIZE;
};

export const isSmallMobile = () => {
    return window.innerWidth < MOBILE_SMALL_WIDTH;
};

export const isShortMobile = () => {
    return window.innerHeight < MOBILE_SMALL_HEIGHT;
};

export const makeLinkPretty = (link) => {
    if (!link) return '';
    return link.replace(/(http(s?))\:\/\//gi, 'www.');
};

export const getUrlsFromText = (text) => {
    if (!text) return;

    const urlPattern = /(https?\:\/\/|www.)([^\/\s]*)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#]*)#?([^ \#]*)/ig;
    return text.match(urlPattern);
};

export function isEmailValid(email) {
    if (!email) return;

    var re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'i');
    return re.test(email);
}

export function isPasswordInvalid(password) {
    if (!password) return;

    if (password.length < 8) {
        return "Password is too short. Must be at least 8 letters";
    }
    return false;
}

export function isPhoneNumberDigits(digits) {
    if (!digits) return;

    const re = new RegExp(/^[0-9\+|\#|\*]+$/);
    return re.test(digits);
}

export function isPhoneNumberValid(phone) {
    if (!phone) return;

    const re = new RegExp(/^(?:\#|\*|[0-9]){1}([0-9]){2,10}(?:\#|\*|[0-9]){1}$/);
    return re.test(phone);
}

export function isFBPageUrlValid(url) {
    if (!url) return;

    const re = new RegExp(/(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*?(\/)?([^/?]*)/);
    return re.test(url);
}


export function isNumber(number) {
    if (!number) return;

    const re = new RegExp(/^[0-9\+]+$/);
    return re.test(number);
}

export const insertLinksToText = text => {
    if (!text) return;

    // add links for the description
    let urls = getUrlsFromText(text);

    let textWithLinks = text;
    if (urls) {
        urls.map(u => {
            let newUrl = u;
            if (u.includes('www.') && (!u.includes('http://') && !u.includes('https://'))) {
                newUrl = u.replace('www.', 'http://');
            }

            textWithLinks = textWithLinks.replace(u, `<a href="${newUrl}" target="_blank">${u}</a>`);
        });
    }

    return textWithLinks;
};

export function isTokenExpired(token) {
    var payload = token.split('.')[1];
    payload = window.atob(payload);
    payload = JSON.parse(payload);

    return payload.exp < Date.now() / 1000;
}

export function getUsernameFromToken(token) {
    if (!token) return {};

    const jwtData = token.split('.')[1];
    if (!jwtData) return {};

    const dataRaw = window.atob(jwtData);
    if (!dataRaw) return {};

    const userData = JSON.parse(dataRaw);
    let userName = "user";
    const userEmail = userData.name;
    if (userData.name) {
        const nameMatch = userData.name.match(/^([^@]*)@/);
        if (nameMatch) {
            userName = nameMatch[1];
        }
        else {
            userName = userData.name;
        }
    }

    return { userName, userEmail};
}

export function getUserIdFromToken(token) {
    var payload = token.split('.')[1];
    payload = window.atob(payload);
    payload = JSON.parse(payload);
    return payload._id;
}

export function convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
            if (ctr > 0) result += columnDelimiter;

            result += item[key];
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

export function youtube_parser(url){
    if (!url) return;
    const onlyWithId = url.split('&')[0];
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\?]*).*/;
    const match = onlyWithId.match(regExp);
    const id = (match && match[7].length===11) ? match[7] : false;

    if (id) {
        return "https://www.youtube.com/embed/" + id;
    }
    return false;
}

export const getYoutubeId = url => {
    if (!url || !url.includes('embed')) return;

    // url example - https://www.youtube.com/embed/D0W1v0kOELA
    return url.split('/')[4];
};

export const isVideo = url => {
    if (!url || (!url.includes('vimeo') && !url.includes('youtube'))) return;

    const youtubeReg = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\?]*).*/;
    const viemoReg = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;

    return url.match(youtubeReg) || url.match(viemoReg);
};

export function vimeo_parser(url, isAutoplay, isNoCotrols) {
    const regExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;

    const match = url.match(regExp);
    if (match) {
        return 'https://player.vimeo.com/video/' + match[1] + '?' + (isNoCotrols ? 'background=1&' : '') + (isAutoplay ? 'autoplay=1&' : '');
    }
    return false;
}

export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeAll(str) {
    if (!str) return '';

    const arr = str.split(' ');
    const newArr = [];
    arr.forEach(s => newArr.push(capitalize(s)));
    return newArr.join(' ');
}

export function getRandomInRange(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

export function isBandFinderType(type) {
    return type === BAND || type === MUSICIAN;
}

export function isBrowserSafari() {
    const userAgent = navigator.userAgent;
    return userAgent.includes('Safari') && !userAgent.includes('Chrome') && !userAgent.includes('Firefox');
}

// https://www.youtube.com/watch?v=-sNWKbnaFkg&ab_channel=AxelThesleff
export const getQueryParamFromUrl = (url, param) => {
    if (!url) return '';
    const urlsParamsRaw = url.split('?')[1] || '';

    if (!urlsParamsRaw) return '';

    const paramsArr = urlsParamsRaw.split('&');

    if (!paramsArr || paramsArr.length < 1) return '';

    const keyValuePair = paramsArr.find(p => {
        const pArr = p.split('=');
        return pArr[0] === param;
    });

    return keyValuePair.split('=')[1] || '';
};

export const getCrossedBandFinder = type => {
    if (type === BAND) return MUSICIAN;

    return BAND;
};

export const isCharHebrew = char => {
    if (!char) return;

    const rtl_rx = /[\u0591-\u07FF]/;
    return rtl_rx.test(char)
};

export const getTokenPayload = token => {
    if (!token) return;

    const base64Str = token.split('.')[1];
    if (!base64Str) return;

    const payloadStr = new Buffer(base64Str, 'base64').toString('ascii');
    let payload;
    try {
        payload = JSON.parse(payloadStr);
    } catch(err) {
        return;
    }

    return payload;
}

export const isCountryCounter = (type, defaults, pinCount) => {
    if (!type || !defaults || !pinCount) return;

    if (type === LIVE_MUSIC) return defaults.liveMusicMinCounter < pinCount;
    if (type === SERVICE) return defaults.serviceMinCounter < pinCount;
    if (type === BAND) return defaults.bandMinCounter < pinCount;
    if (type === MUSICIAN) return defaults.musicianMinCounter < pinCount;
}



// WEBPACK FOOTER //
// ./src/utils.js